// extracted by mini-css-extract-plugin
export default {"micro-app-loading":"micro-app-div_micro-app-loading__k4KRo","microAppLoading":"micro-app-div_micro-app-loading__k4KRo"};